import React from 'react';
import { Link } from 'react-router-dom';
import { Star } from 'lucide-react';
import { shopData, type Product } from './shopData';
import { useReviewStats } from '../../../utils/useReviewStats';
export function CompleteYourStack({
  product
}: {
  product: Product;
}) {
  const reviewStats = useReviewStats();
  // Get up to 4 other products to recommend
  const recommendations = shopData.filter(p => p.id !== product.id).slice(0, 4);
  if (recommendations.length === 0) return null;
  return <section className="font-sans bg-[#F9F9F9] py-16 md:py-24 mt-16 md:mt-24 border-t border-[#E5E5E5]" data-id="element-2192">
      <div className="max-w-7xl mx-auto px-6" data-id="element-2193">
        <h2 className="text-3xl md:text-4xl font-bold text-[#1F1F1F] mb-3 tracking-tight" data-id="element-2194">
          Complete Your Stack
        </h2>
        <p className="text-base text-[#5A5A5A] mb-10" data-id="element-2195">
          Pair {product.name} with these products for a complete foundational
          stack.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-2196">
          {recommendations.map(rec => {
          const stats = reviewStats[rec.id] || {
            avg: 0,
            count: 0
          };
          return <div key={rec.id} className="bg-white border border-[#E5E5E5] rounded-md flex flex-col overflow-hidden hover:shadow-lg transition-shadow" data-id="element-2197">
                {/* Tinted Header */}
                <div className="bg-[#F0F4F8] py-3 px-4 text-center border-b border-[#E5E5E5]" data-id="element-2198">
                  <span className="text-sm font-semibold text-[#1F1F1F]" data-id="element-2199">
                    {rec.category}
                  </span>
                </div>

                {/* Image */}
                <Link to={`/shop/${rec.id}`} className="p-6 aspect-square flex items-center justify-center bg-white group" data-id="element-2200">
                  <img src={rec.image} alt={rec.name} className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300" data-id="element-2201" />
                </Link>

                {/* Content */}
                <div className="p-6 pt-2 flex flex-col flex-1" data-id="element-2202">
                  {/* Rating */}
                  <div className="flex items-center gap-1 mb-3" data-id="element-2203">
                    <div className="flex items-center" data-id="element-2204">
                      {[1, 2, 3, 4, 5].map(star => <Star key={star} className={`w-4 h-4 ${star <= Math.round(stats.avg) ? 'fill-[#1F73B7] text-[#1F73B7]' : 'text-[#D8D8D0]'}`} data-id="element-2205" />)}
                    </div>
                    <span className="text-xs text-[#5A5A5A] ml-1" data-id="element-2206">
                      {stats.count} Reviews
                    </span>
                  </div>

                  {/* Title */}
                  <Link to={`/shop/${rec.id}`} className="hover:text-[#1F73B7] transition-colors" data-id="element-2207">
                    <h3 className="text-lg font-bold text-[#1F1F1F] mb-3 leading-tight" data-id="element-2208">
                      {rec.name}
                    </h3>
                  </Link>

                  {/* Description */}
                  <p className="text-sm text-[#5A5A5A] leading-relaxed mb-6 flex-1" data-id="element-2209">
                    {rec.shortDescription}
                  </p>

                  {/* Meta */}
                  <p className="text-xs text-[#9A9A90] mb-4" data-id="element-2210">
                    1 Flavor available
                  </p>

                  {/* Button */}
                  <Link to={`/shop/${rec.id}`} className="w-full py-3.5 bg-[#111111] text-white text-sm font-bold text-center rounded hover:bg-[#3B3B3B] transition-colors mt-auto" data-id="element-2211">
                    Shop Now
                  </Link>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}